module.exports = __webpack_public_path__ + "img/imgProfile1.f24e1080.png";